import React from 'react'

export const ProductDetails = () => {
    return (
        <div>
            
        </div>
    )
}
